/* eslint-disable */

import { getServerUrl } from './getServerUrl.js';
import { getYoutubeVideoId } from './getYoutubeVideoId.js';

const STANDALONE_PLAYER_PATH = 'hosted/youtubePlayer.html';

const YOUTUBE_HOSTNAMES = [
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com',
  'youtu.be',
  'www.youtu.be',
];

// Player params our standalone page passes through to the YouTube player.
const PASSTHROUGH_PARAMS = [
  'autoplay',
  'cc_lang_pref',
  'cc_load_policy',
  'color',
  'controls',
  'disablekb',
  'end',
  'fs',
  'hl',
  'loop',
  'mute',
  'playlist',
  'start',
];

function extractVideoId(url) {
  try {
    return getYoutubeVideoId(url.href);
  } catch (e) {
    // getYoutubeVideoId throws for playlists, channels, search results and shorts.
    const shorts = url.pathname.match(/^\/shorts\/([\w-]{11})/);
    return shorts ? shorts[1] : null;
  }
}

// ?t= accepts plain seconds or the 1h2m3s form; ?start= is always seconds.
function parseStartSeconds(value) {
  if (/^\d+s?$/.test(value)) return parseInt(value, 10);
  const parts = value.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
  if (!parts || !parts.slice(1).some(Boolean)) return null;
  return (+parts[1] || 0) * 3600 + (+parts[2] || 0) * 60 + (+parts[3] || 0);
}

export function rewriteYoutubeEmbedUrl(embedUrl) {
  if (typeof embedUrl !== 'string' || !embedUrl.trim().length) return embedUrl;

  // Only some stores decode iframe_q interactionText on load, so accept either form.
  let candidate = embedUrl.trim();
  if (!candidate.includes('://') && /%3A%2F%2F/i.test(candidate)) {
    try {
      candidate = decodeURIComponent(candidate);
    } catch (e) {
      return embedUrl;
    }
  }

  let url;
  try {
    url = new URL(candidate);
  } catch (e) {
    return embedUrl; // not an absolute URL, leave it alone
  }
  if (!YOUTUBE_HOSTNAMES.includes(url.hostname.toLowerCase())) return embedUrl;

  const youtubeVideoId = extractVideoId(url);
  if (!youtubeVideoId) return embedUrl; // a YouTube URL, but not a single video

  const params = new URLSearchParams({ v: youtubeVideoId });
  PASSTHROUGH_PARAMS.forEach((key) => {
    if (url.searchParams.has(key)) params.set(key, url.searchParams.get(key));
  });
  if (!params.has('start')) {
    const start = parseStartSeconds(url.searchParams.get('t') || url.searchParams.get('time_continue') || '');
    if (start) params.set('start', start);
  }

  return `${getServerUrl()}${STANDALONE_PLAYER_PATH}?${params}`;
}
